import { render, staticRenderFns } from "./multistep.vue?vue&type=template&id=1126c717&"
import script from "./multistep.vue?vue&type=script&lang=js&"
export * from "./multistep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1126c717')) {
      api.createRecord('1126c717', component.options)
    } else {
      api.reload('1126c717', component.options)
    }
    module.hot.accept("./multistep.vue?vue&type=template&id=1126c717&", function () {
      api.rerender('1126c717', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/form-template/multistep.vue"
export default component.exports